import { NavLink } from 'react-router-dom'
import { MOBILE_GROUPS, type MobileNavItem } from './mobileNav'

interface Props {
  isAdmin: boolean
  cadastroRecAvailable: boolean
  /** Chamado ao tocar num tile (ex.: fechar o sheet). */
  onNavigate?: () => void
}

/**
 * Launcher em grid (estilo "serviços"): seções com título + tiles arredondados com
 * ícone SVG num selo tonal, rótulo em negrito e badge "Novo". Reusa MOBILE_GROUPS e o
 * mesmo filtro de permissão do MoreSheet. Usado no "Mais" (v2) e na tela Início.
 */
export default function MobileLauncherGrid({ isAdmin, cadastroRecAvailable, onNavigate }: Props) {
  const visible = (i: MobileNavItem) =>
    (!i.adminOnly || isAdmin) && (!i.cadastroGated || cadastroRecAvailable)

  return (
    <div className="space-y-5">
      {MOBILE_GROUPS.map(group => {
        const items = group.items.filter(visible)
        if (items.length === 0) return null
        return (
          <section key={group.title}>
            <h3 className="text-sm font-display font-bold text-ink mb-2.5 px-0.5">{group.title}</h3>
            <div className="grid grid-cols-3 gap-2.5">
              {items.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    `relative flex flex-col items-center gap-2 rounded-2xl border p-3 pt-4 text-center transition-colors touch-action-manip no-tap-highlight ${
                      isActive
                        ? 'bg-brand-600/10 border-brand-600/40 dark:bg-brand-500/15 dark:border-brand-500/40'
                        : 'bg-surface border-line active:bg-sunken'
                    }`
                  }
                >
                  {item.badge && (
                    <span className="absolute top-1.5 right-1.5 text-[8px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-terra text-white">
                      {item.badge}
                    </span>
                  )}
                  <span className="flex items-center justify-center w-11 h-11 rounded-2xl bg-brand-500/10 text-brand-600 dark:text-brand-400 shrink-0">
                    {item.Icon ? <item.Icon className="w-6 h-6" /> : <span className="text-2xl leading-none">{item.icon}</span>}
                  </span>
                  <span className="text-[11px] font-semibold text-ink leading-tight">{item.label}</span>
                </NavLink>
              ))}
            </div>
          </section>
        )
      })}
    </div>
  )
}
